export const initialState = {
    sex: '',
    birthDate: '',
    birthDateYYYY: '',
    birthDateMM: '',
    birthDateDD: '',
    FatherHeight: null,
    MotherHeight: null,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'CHILD_UPDATE':
            return {
                ...state,
                ...action,
            };
        case 'CHILD_RESET':
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
